'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$LocalPjeOfficeCertChainRequest(origin) {
  this.Ce = null;
  this.Ce = origin;
}
export { $c_Lpresto_AgentView$LocalPjeOfficeCertChainRequest as $c_Lpresto_AgentView$LocalPjeOfficeCertChainRequest };
$p = $c_Lpresto_AgentView$LocalPjeOfficeCertChainRequest.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$LocalPjeOfficeCertChainRequest;
/** @constructor */
function $h_Lpresto_AgentView$LocalPjeOfficeCertChainRequest() {
}
export { $h_Lpresto_AgentView$LocalPjeOfficeCertChainRequest as $h_Lpresto_AgentView$LocalPjeOfficeCertChainRequest };
$h_Lpresto_AgentView$LocalPjeOfficeCertChainRequest.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_AgentView$LocalPjeOfficeCertChainRequest) && (this.Ce === x$0.Ce)));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 1;
});
$p.s = (function() {
  return "LocalPjeOfficeCertChainRequest";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.Ce;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.pv = (function() {
  return this.Ce;
});
function $isArrayOf_Lpresto_AgentView$LocalPjeOfficeCertChainRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hA)));
}
export { $isArrayOf_Lpresto_AgentView$LocalPjeOfficeCertChainRequest as $isArrayOf_Lpresto_AgentView$LocalPjeOfficeCertChainRequest };
var $d_Lpresto_AgentView$LocalPjeOfficeCertChainRequest = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$LocalPjeOfficeCertChainRequest, "presto.AgentView$LocalPjeOfficeCertChainRequest", ({
  hA: 1,
  b5: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_AgentView$LocalPjeOfficeCertChainRequest as $d_Lpresto_AgentView$LocalPjeOfficeCertChainRequest };
//# sourceMappingURL=presto.-Agent-View$-Local-Pje-Office-Cert-Chain-Request.js.map
